import React from "react";
import { Style } from "./style";
import { InterphoneListViewProps } from "./type";
import { getAmPm } from "../../utils/util";
import CardContentModal from "../../components/modal/CardContentModal";
import { BackButton } from "../../components/BackButton";
import { langText } from "../../recoil/lang";

const InterphoneListView = ({ queries, hook }: InterphoneListViewProps) => {
  return (
    <>
      <Style>
        <div
          className="wrap"
          onTouchStart={hook.resetTimer}
          onClick={hook.resetTimer}
          onScrollCapture={hook.resetTimer}
        >
          <div className="header">
            <BackButton pathname="interphoneList" />
          </div>
          <h1>{langText.interphone_area_title[hook.lang]}</h1>
          <div className="listWrap">
            {queries.interphoneArea &&
              queries.interphoneArea.map((item) => (
                <div key={item.hotel_area_id} className="listItemWrap">
                  <div className="listItem">
                    <div className="head">
                      <div>
                        <h2>{item.name}</h2>
                        <h4>{`${getAmPm(item.open_time)} - ${getAmPm(
                          item.close_time
                        )}`}</h4>
                      </div>
                    </div>
                    <h4>{item.description}</h4>
                    {item.card_id && (
                      <button
                        className="details"
                        onClick={() => hook.openCard(item)}
                      >
                        {item.card_title}
                        <img
                          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_right_green.svg`}
                          alt="right"
                        />
                      </button>
                    )}
                  </div>
                  <button
                    className="call"
                    onClick={() => hook.requestVoiceChat(item.hotel_area_id)}
                  >
                    <div className="buttonWrap">
                      <img
                        src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_calling.svg`}
                        alt="call"
                      />
                    </div>
                  </button>
                </div>
              ))}
          </div>
        </div>
      </Style>
      {hook.selectedCard && (
        <CardContentModal cardData={hook.selectedCard} type={"interphone"} />
      )}
    </>
  );
};
export default InterphoneListView;
